export default {
  get name(): string {
    return 'ExponentIntentLauncher';
  },
};
